import userResources from "api/userResources";
import Logo from "components/Home/Logo/Logo";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { logo3 } from "utils/images";
import { logo2 } from "utils/images";
import { logo1 } from "utils/images";

export default function AirticketInvoiceModal({ data, close, history }) {
  const [headingSize, setHeadingSize] = useState("text-xl");
  const [paragraphSize, setParagraphSize] = useState("text-xl");
  const [showSupplier, setShowSupplier] = useState(false);
  const [disable, setDisable] = useState(false);

  const {
    invoice_main_id,
    passenger_details,
    flight_details,
    airticket_from_pax,
    airticket_to_supplier,
    booking_date,
    departure_date,
    gds_locator,
    gds_type,
    ticket_number,
    fromAirport,
    toAirport,
    sales_agents,
    special_remarks,
    other_remarks,
    invoice_number,
    customer_details,
    passengers,
    itinerary,
    created_at,
    valid_canadian_passport,
    canadian_citizenship_or_prCard,
    valid_travel_visa,
    tourist_card,
    supplier,
    airLine,
    mco,
    ref_no_et,
    status,
  } = data;

  const toBoolean = (value) => String(value).toLowerCase() === "true";

  const totalPassenger =
    Number(passengers?.adt) + Number(passengers?.chd) + Number(passengers?.inf);

  const documents = [
    { label: "Valid Passport", value: valid_canadian_passport },
    {
      label: "Canadian Citizenship or PR Card",
      value: canadian_citizenship_or_prCard,
    },
    { label: "Valid Travel Visa", value: valid_travel_visa },
    { label: "Tourist Card", value: tourist_card },
  ];

  // Helper function: safely parses a value as a float; returns 0 if the value is null/undefined or cannot be parsed as a number.
  function safeParseFloat(value) {
    if (value == null) return 0;
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }

  // Ensure values are converted correctly to numbers (including decimals) or default to 0.
  const paxTotal = safeParseFloat(airticket_from_pax?.total);
  const supplierTotal = safeParseFloat(airticket_to_supplier?.total);
  const commissionSupplier = safeParseFloat(
    airticket_to_supplier?.payment_received_from_supplier
  );
  const recallCommissionSupplier = safeParseFloat(
    airticket_to_supplier?.recall_commission_to_supplier
  );
  const paymentMade = safeParseFloat(airticket_to_supplier?.paymentMade);
  const supplierRefund = safeParseFloat(airticket_to_supplier?.refund);
  const paxRefund = safeParseFloat(airticket_from_pax?.refund);

  const commissionReceivedOrNot =
    airticket_to_supplier?.commission_from_supplier;

  const refundReceivedFromSupplier = toBoolean(
    airticket_to_supplier?.refund_received_from_supplier
  );

  // Convert the string "true"/"false" to a boolean
  const isCommissionReceived = commissionReceivedOrNot === "true";

  const finalPaxTotal = safeParseFloat(paxTotal) - safeParseFloat(paxRefund);
  const finalSupplierTotal =
    safeParseFloat(supplierTotal) - safeParseFloat(supplierRefund);
  const cashInhand = safeParseFloat(airticket_to_supplier?.cash_in_hand);

  const cashInhandTotalpassenger = cashInhand * totalPassenger;

  // Final profit calculation with 2 decimal precision
  const profit = +(
    finalPaxTotal -
    finalSupplierTotal +
    cashInhandTotalpassenger
  ).toFixed(2);

  const noRefund = refundReceivedFromSupplier ? 0 : supplierRefund || 0;
  const adjustCommission =
    supplierRefund && commissionSupplier ? commissionSupplier : 0;
  const recall = recallCommissionSupplier || 0;

  const supplierBalance = parseFloat(
    (
      paymentMade -
      supplierTotal -
      commissionSupplier +
      noRefund -
      adjustCommission +
      recall
    ).toFixed(2)
  );

  useEffect(() => {
    if (showSupplier === true) {
      setHeadingSize("text-lg");
      setParagraphSize("text-md");
    } else if (flight_details?.length > 2 && flight_details?.length < 6) {
      setHeadingSize("text-lg");
      setParagraphSize("text-lg");
    } else {
      setHeadingSize("text-xl");
      setParagraphSize("text-xl");
    }
  }, [flight_details?.length, showSupplier]);

  const mailSender = async (invoice_main_id) => {
    setDisable(true);
    try {
      const res = await userResources.invoiceMailsender(invoice_main_id);

      if (res?.data?.status && res?.data?.message?.flash_type === "success") {
        toast.success(
          res.data.message.flash_message || "Mail sent successfully!"
        );
      } else {
        toast.error(
          res?.data?.message?.flash_message || "Failed to send mail."
        );
      }
    } catch (error) {
      toast.error("Server error. Please try again later.");
    } finally {
      setDisable(false); // ✅ Always re-enable the button
    }
  };

  return (
    <>
      {/* Global print CSS to remove scrollbars and minimize spacing */}
      <style>{`
  @media print {
    /* Hide everything by default */
    body * {
      visibility: hidden;
      font-family: Arial, sans-serif;
    }
    /* Make the invoice content visible */
    #invoice-content, #invoice-content * {
      visibility: visible;
    }
    /* Fix header and footer so they repeat on every page */
    #invoice-header, #invoice-footer {
      position: fixed;
      left: 0;
      right: 0;
    }
    #invoice-header {
      top: 0;
      /* set a height if needed */
      height: 190px;
    }
    #invoice-footer{
      bottom: 0px;
    }
    /* Make sure the body has top and bottom margins to avoid overlap */
    #invoice-body {
      margin-top: 170px;  /* slightly more than header height */
      margin-bottom: 60px; /* slightly more than footer height */
    }
    @page {
      margin: 0 !important;
    }
    html, body {
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
    }
    /* Other print adjustments as before */
    * {
      overflow: visible !important;
      -ms-overflow-style: none !important;
      scrollbar-width: none !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    ::-webkit-scrollbar {
      display: none !important;
    }
    .overflow-x-auto {
      overflow: visible !important;
    }
    .no-print {
      display: none !important;
    }
    .modal, .modal-box {
      margin: 0 !important;
      padding: 0 !important;
      box-shadow: none !important;
      border: none !important;
    }
  }
`}</style>
      <div className="modal modal-open">
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            className="h-screen w-screen overflow-auto rounded-none bg-white p-0 text-black shadow-xl"
            id="invoice-content"
          >
            {/* Header Section */}
            <div
              id="invoice-header"
              className="bg-gradient-to-r from-black to-blue-900 px-10 py-5 text-white"
            >
              <div className="flex items-center justify-between">
                <div>
                  <Logo
                    logo1={logo1}
                    logo2={logo2}
                    width={{
                      logo1: "w-32",
                      logo2: "w-80 mt-1",
                    }}
                  />
                </div>
                <div className="no-print">
                  <h4 className="mb-2  text-center text-lg font-bold">
                    {showSupplier
                      ? "INVOICE SUPPLIER VERSION"
                      : "INVOICE PASSENGER VERSION"}
                  </h4>
                  <div className="mb-2 flex flex-col items-center justify-center gap-2">
                    <label
                      htmlFor="supplier-toggle"
                      className="flex cursor-pointer items-center gap-2"
                    >
                      <span className="text-lg font-medium">Supplier View</span>
                      <input
                        id="supplier-toggle"
                        type="checkbox"
                        checked={showSupplier}
                        onChange={() => setShowSupplier((prev) => !prev)}
                        className={`toggle toggle-sm ${
                          showSupplier
                            ? "bg-green-500 hover:bg-gray-400"
                            : "bg-gray-400 hover:bg-green-500"
                        }`}
                        aria-label="Toggle supplier view"
                      />
                    </label>
                  </div>
                </div>
                <div className={`text-md text-right`}>
                  <p className="">Invoice No: {invoice_number}</p>
                  <p className="">
                    Invoice Date: {new Date(created_at).toLocaleDateString()}
                  </p>

                  <p className="">Client No: {customer_details.phone_number}</p>
                  <p className="">
                    GDS: {gds_type} | PNR: {gds_locator}
                  </p>
                  <p className="">TICO REGISTRATION NO.: 12345 (RETAIL)</p>
                  <p className="">
                    TICO REGISTRATION NO.: 12345 (WHOLESALE)
                  </p>
                  {/* Wrap supplier view toggle in no-print */}
                </div>
              </div>
            </div>

            <div id="invoice-body" className="p-10 pb-2">
              {/* Flight & Passenger Header */}
              <div className="">
                <div className=" grid grid-cols-5">
                  <div>
                    <p
                      className={`${headingSize} font-semibold uppercase tracking-wide`}
                    >
                      Booking Date
                    </p>
                    <p className={`${paragraphSize} text-gray-800`}>
                      {booking_date}
                    </p>
                  </div>
                  <div>
                    <p
                      className={`${headingSize} font-semibold uppercase tracking-wide`}
                    >
                      Booking Agent
                    </p>
                    <p className={`${paragraphSize} text-gray-800`}>
                      {sales_agents?.name}
                    </p>
                  </div>
                  {supplier && showSupplier && (
                    <div>
                      <p
                        className={`${headingSize} font-semibold uppercase tracking-wide`}
                      >
                        Supplier
                      </p>
                      <p className={`${paragraphSize} text-gray-800`}>
                        {supplier?.name}
                      </p>
                    </div>
                  )}
                  <div>
                    <p
                      className={`${headingSize} font-semibold uppercase tracking-wide`}
                    >
                      Ticket Number
                    </p>
                    <p className={`${paragraphSize} font-mono text-blue-600`}>
                      {ticket_number}
                    </p>
                  </div>
                  <div>
                    <p
                      className={`${headingSize} font-semibold uppercase tracking-wide`}
                    >
                      Ticket status
                    </p>
                    <p className={`${paragraphSize} font-mono`}>{status}</p>
                  </div>
                </div>

                <div className="grid grid-cols-5 text-sm">
                  <div className="col-span-2">
                    <p className={`${headingSize} mb-1 font-semibold`}>
                      Bill To:
                    </p>

                    {customer_details ? (
                      <div className={`flex flex-col gap-1 ${paragraphSize}`}>
                        <div className="flex gap-2">
                          {" "}
                          {customer_details.full_name && (
                            <p className="text-gray-800">
                              {customer_details.full_name},
                            </p>
                          )}
                          {customer_details.city_name && (
                            <p className="uppercase text-gray-800">
                              {customer_details.city_name},
                            </p>
                          )}
                          {customer_details.phone_number && (
                            <p className="text-gray-800">
                              {customer_details.phone_number}
                            </p>
                          )}
                        </div>
                        {customer_details.address && (
                          <p className="text-gray-800">
                            {customer_details.address}
                          </p>
                        )}
                      </div>
                    ) : (
                      <p className="italic text-gray-500">
                        No customer details provided
                      </p>
                    )}
                  </div>
                  {mco && (
                    <div>
                      <p
                        className={`${headingSize} font-semibold uppercase tracking-wide`}
                      >
                        Mco
                      </p>
                      <p className={`${paragraphSize}`}>{mco}</p>
                    </div>
                  )}
                  {ref_no_et && (
                    <div>
                      <p
                        className={`${headingSize} font-semibold uppercase tracking-wide`}
                      >
                        Ref NO
                      </p>
                      <p className={`${paragraphSize}`}>{ref_no_et}</p>
                    </div>
                  )}

                  <div>
                    {airLine && (
                      <div>
                        <p className={`${headingSize} font-semibold`}>
                          Airline
                        </p>
                        <p className={`${paragraphSize}`}>
                          {airLine?.airline_name}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="col-span-2">
                    <h2 className={`${headingSize} font-bold`}>
                      {fromAirport?.name} &rarr; {toAirport?.name}
                    </h2>
                    <p className="text-md ">{departure_date}</p>
                  </div>
                  {/* <div className="col-span-3">
                  <p className={`${headingSize} font-semibold`}>Itinerary</p>
                  <p className={`${paragraphSize}`}>{itinerary}</p>
                </div> */}
                </div>
              </div>

              <div>
                <p className={`${headingSize} font-semibold`}>Passengers</p>
                <div className={`flex flex-wrap gap-2`}>
                  {passenger_details?.map((passenger, index) => (
                    <div key={index} className={`${paragraphSize}`}>
                      {passenger.title} {passenger.first_name}{" "}
                      {passenger.last_name}
                      {index !== passenger_details.length - 1 && ", "}
                    </div>
                  ))}
                </div>
              </div>

              {/* Flight Itinerary */}
              <div className={``}>
                <div className="mt-2">
                  <p
                    className={`bg-gradient-to-r from-black to-blue-900 px-2 text-white ${headingSize}`}
                  >
                    FLIGHT INFORMATION
                  </p>
                  <div className="overflow-x-auto">
                    <table className={`w-full table-auto ${headingSize}`}>
                      <thead className="bg-blue-50">
                        <tr>
                          <th className="px-1 py-0 text-left">Airline</th>
                          <th className="px-1 py-0 text-left">Flight No.</th>
                          <th className="px-1 py-0 text-left">From</th>
                          <th className="px-1 py-0 text-left">To</th>
                          <th className="px-1 py-0 text-left">Arrival Date</th>
                          <th className="px-1 py-0 text-left">
                            Departure Time
                          </th>
                          <th className="px-1 py-0 text-left">Arrival Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {flight_details?.map((flight, index) => (
                          <tr
                            key={index}
                            className={`border-b ${paragraphSize}`}
                          >
                            <td className="px-1 py-0">{flight.airline}</td>
                            <td className="px-1 py-0">{flight.flight_no}</td>
                            <td className="px-1 py-0">{flight.from}</td>
                            <td className="px-1 py-0">{flight.to}</td>
                            <td className="px-1 py-0">{flight.date}</td>
                            <td className="px-1 py-0">{flight.dep_time}</td>
                            <td className="px-1 py-0">{flight.arr_time}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="mt-5">
                  {!showSupplier && (
                    <div className="bg-gray-100">
                      <div className="grid grid-cols-4 bg-gradient-to-r from-blue-900 to-black px-2 text-white">
                        <p></p>
                        <p className="text-right">Base Fare</p>
                        <p className="text-right">GST/HST</p>
                        <p className="text-right">Taxes</p>
                      </div>
                      <div className={`p-2 ${headingSize}`}>
                        <div className="grid grid-cols-4">
                          <p className="font-semibold">
                            {Number(passengers?.adt)} Adult
                          </p>
                          <p className="text-right ">
                            {" "}
                            {isNaN(airticket_from_pax?.baseFare?.adt1)
                              ? 0
                              : airticket_from_pax?.baseFare?.adt1}
                          </p>
                          <p className="text-right">
                            {isNaN(airticket_from_pax?.gstHst?.adt1)
                              ? 0
                              : airticket_from_pax?.gstHst?.adt1}
                          </p>
                          <p className="text-right">
                            {" "}
                            {isNaN(airticket_from_pax?.taxes?.adt1)
                              ? 0
                              : airticket_from_pax?.taxes?.adt1}
                          </p>
                        </div>
                        <div className="grid grid-cols-4">
                          <p className="font-semibold">
                            {" "}
                            {Number(passengers?.chd)} Child
                          </p>
                          <p className="text-right">
                            {isNaN(airticket_from_pax?.baseFare?.chd1)
                              ? 0
                              : airticket_from_pax?.baseFare?.chd1}
                          </p>{" "}
                          <p className="text-right">
                            {isNaN(airticket_from_pax?.gstHst?.chd1)
                              ? 0
                              : airticket_from_pax?.gstHst?.chd1}
                          </p>
                          <p className="text-right">
                            {" "}
                            {isNaN(airticket_from_pax?.taxes?.chd1)
                              ? 0
                              : airticket_from_pax?.taxes?.chd1}
                          </p>
                        </div>
                        <div className="grid grid-cols-4">
                          <p className="font-semibold">
                            {Number(passengers?.inf)} Infant
                          </p>
                          <p className="text-right">
                            {" "}
                            {isNaN(airticket_from_pax?.baseFare?.inf1)
                              ? 0
                              : airticket_from_pax?.baseFare?.inf1}
                          </p>
                          <p className="text-right">
                            {isNaN(airticket_from_pax?.gstHst?.inf1)
                              ? 0
                              : airticket_from_pax?.gstHst?.inf1}
                          </p>
                          <p className="text-right">
                            {" "}
                            {isNaN(airticket_from_pax?.taxes?.inf1)
                              ? 0
                              : airticket_from_pax?.taxes?.inf1}
                          </p>
                        </div>
                      </div>
                      <div className="p-2">
                        {/* Divider */}
                        <div className="my-2 border-t"></div>
                        {/* Summary Section */}
                        <div className={`w-full ${headingSize}`}>
                          <div className="flex justify-between py-0">
                            <span className="font-bold">Total Amount:</span>
                            <span className="text-right">
                              ${airticket_from_pax?.total}
                            </span>
                          </div>
                          <div className="flex justify-between py-0">
                            <span className="font-bold">Amount Paid:</span>
                            <span className="text-right">
                              ${airticket_from_pax?.amountPaid}
                            </span>
                          </div>
                          {airticket_from_pax?.refund && (
                            <div className="flex justify-between py-0">
                              <span className="font-bold">Refund:</span>
                              <span className="text-right">
                                <span>
                                  $
                                  {isNaN(airticket_from_pax?.refund)
                                    ? 0
                                    : airticket_from_pax?.refund}
                                </span>
                              </span>
                            </div>
                          )}

                          {airticket_from_pax?.refund_paid && (
                            <div className="flex justify-between py-0">
                              <span className="font-bold">Refund Paid:</span>
                              <span className="text-right">
                                <span>
                                  $
                                  {isNaN(airticket_from_pax?.refund_paid)
                                    ? 0
                                    : airticket_from_pax?.refund_paid}
                                </span>
                              </span>
                            </div>
                          )}

                          <div className="flex justify-between py-0 font-bold">
                            <span className="font-bold">Balance Due:</span>
                            <span className="text-right">
                              <span
                                className={
                                  airticket_from_pax?.balance == 0
                                    ? ""
                                    : "text-red-600"
                                }
                              >
                                ${airticket_from_pax?.balance}
                              </span>
                            </span>
                          </div>

                          <div className="flex justify-between py-0">
                            <span className="font-bold">Payment Method:</span>
                            <span className="text-right">
                              <span>
                                {airticket_from_pax?.transaction_type_name ||
                                  "N/A"}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <p className={`mt-2 ${headingSize}`}>
                Please review your itinerary to ensure that all information is
                correct. Check-in 2-3 hours prior to departures. Re-confirm
                flight times at least 24hrs prior to departures as they are
                subject to change. Tickets are fully non-refundable unless
                otherwise stated.
              </p>
              {/* Financial Section */}
              {showSupplier && (
                <div className="grid grid-cols-2 gap-2 py-2">
                  {/* Payment Details from Pax */}
                  <div className="rounded-lg bg-gray-100 p-4">
                    <div className="mb-2 grid grid-cols-4 justify-between bg-gray-400 px-2 text-black">
                      <p></p>
                      <p className="text-right">
                        {Number(passengers?.adt)} Adult
                      </p>
                      <p className="text-right">
                        {Number(passengers?.chd)} Child
                      </p>
                      <p className="text-right">
                        {Number(passengers?.inf)} Infant
                      </p>
                    </div>
                    <h3 className="mb-2 text-lg font-bold text-blue-800">
                      Payment Details from Pax
                    </h3>
                    <div>
                      {/* Changed text-sm to text-base to increase text size */}
                      <div className="h-full bg-gray-100 pt-1 text-base text-black">
                        <div className="space-y-2">
                          {/* Cost Breakdown */}
                          <div className="grid grid-cols-4">
                            <p>Base Fare:</p>
                            <p className="text-right ">
                              {isNaN(airticket_from_pax?.baseFare?.adt1)
                                ? 0
                                : airticket_from_pax?.baseFare?.adt1}
                            </p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.baseFare?.chd1)
                                ? 0
                                : airticket_from_pax?.baseFare?.chd1}
                            </p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.baseFare?.inf1)
                                ? 0
                                : airticket_from_pax?.baseFare?.inf1}
                            </p>
                          </div>
                          <div className="grid grid-cols-4">
                            <p>GST/HST:</p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.gstHst?.adt1)
                                ? 0
                                : airticket_from_pax?.gstHst?.adt1}
                            </p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.gstHst?.chd1)
                                ? 0
                                : airticket_from_pax?.gstHst?.chd1}
                            </p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.gstHst?.inf1)
                                ? 0
                                : airticket_from_pax?.gstHst?.inf1}
                            </p>
                          </div>
                          <div className="grid grid-cols-4">
                            <p>Taxes:</p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.taxes?.adt1)
                                ? 0
                                : airticket_from_pax?.taxes?.adt1}
                            </p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.taxes?.chd1)
                                ? 0
                                : airticket_from_pax?.taxes?.chd1}
                            </p>
                            <p className="text-right">
                              {isNaN(airticket_from_pax?.taxes?.inf1)
                                ? 0
                                : airticket_from_pax?.taxes?.inf1}
                            </p>
                          </div>
                          <div className="grid grid-cols-4">
                            <p>Subtotal:</p>
                            <p className="text-right">
                              {airticket_from_pax?.subTotal?.adt1 || 0}
                            </p>
                            <p className="text-right">
                              {airticket_from_pax?.subTotal?.chd1 || 0}
                            </p>
                            <p className="text-right">
                              {airticket_from_pax?.subTotal?.inf1 || 0}
                            </p>
                          </div>
                          {/* Additional Details */}
                          <div className="mt-2 flex justify-between border-t pt-2">
                            <span className="font-bold">Total:</span>
                            <span className="font-bold">
                              ${airticket_from_pax?.total}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span>Total Paid:</span>
                            <span>${airticket_from_pax?.amountPaid}</span>
                          </div>

                          {airticket_from_pax?.refund && (
                            <div className="flex justify-between py-0">
                              <span className="">Refund:</span>
                              <span className="text-right">
                                <span>
                                  $
                                  {isNaN(airticket_from_pax?.refund)
                                    ? 0
                                    : airticket_from_pax?.refund}
                                </span>
                              </span>
                            </div>
                          )}

                          {airticket_from_pax?.refund_paid && (
                            <div className="flex justify-between">
                              <span className="">Refund Paid:</span>
                              <span className="text-right">
                                <span>
                                  $
                                  {isNaN(airticket_from_pax?.refund_paid)
                                    ? 0
                                    : airticket_from_pax?.refund_paid}
                                </span>
                              </span>
                            </div>
                          )}
                          <div className="flex justify-between">
                            <span>Balance Due:</span>
                            <span>${airticket_from_pax?.balance}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="">Payment Method</span>
                            <p>
                              {airticket_from_pax?.transaction_type_name ||
                                "N/A"}
                            </p>
                          </div>
                          <div className="flex justify-between">
                            <span className="">Payment Received From Pax</span>
                            <div className="flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                              {airticket_from_pax?.payment_received_from_pax ===
                              "true" ? (
                                <span className="text-sm text-green-500">
                                  &#10003;
                                </span>
                              ) : (
                                <span className="text-sm text-red-500">
                                  &#10007;
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="flex justify-between">
                            <span>Final Total</span>
                            <span>${finalPaxTotal}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Payment Details to Supplier */}
                  <div className="rounded-lg bg-gray-100 p-4">
                    {/* Passenger Counts Header */}
                    <div className="mb-2 grid grid-cols-4 justify-between bg-gray-400 px-2 text-black">
                      <p></p>
                      <p className="text-right">
                        {Number(passengers?.adt)} Adult
                      </p>
                      <p className="text-right">
                        {Number(passengers?.chd)} Child
                      </p>
                      <p className="text-right">
                        {Number(passengers?.inf)} Infant
                      </p>
                    </div>
                    <h3 className="mb-2 text-lg font-bold text-green-800">
                      Payment Details to Supplier
                    </h3>
                    <div className="space-y-2">
                      {/* Cost Breakdown */}
                      <div className="grid grid-cols-4">
                        <p>Base Fare:</p>
                        <p className="text-right ">
                          {isNaN(airticket_to_supplier?.baseFare?.adt1)
                            ? 0
                            : airticket_to_supplier?.baseFare?.adt1}
                        </p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.baseFare?.chd1)
                            ? 0
                            : airticket_to_supplier?.baseFare?.chd1}
                        </p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.baseFare?.inf1)
                            ? 0
                            : airticket_to_supplier?.baseFare?.inf1}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p>GST/HST:</p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.gstHst?.adt1)
                            ? 0
                            : airticket_to_supplier?.gstHst?.adt1}
                        </p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.gstHst?.chd1)
                            ? 0
                            : airticket_to_supplier?.gstHst?.chd1}
                        </p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.gstHst?.inf1)
                            ? 0
                            : airticket_to_supplier?.gstHst?.inf1}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p>Taxes:</p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.taxes?.adt1)
                            ? 0
                            : airticket_to_supplier?.taxes?.adt1}
                        </p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.taxes?.chd1)
                            ? 0
                            : airticket_to_supplier?.taxes?.chd1}
                        </p>
                        <p className="text-right">
                          {isNaN(airticket_to_supplier?.taxes?.inf1)
                            ? 0
                            : airticket_to_supplier?.taxes?.inf1}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p>Subtotal:</p>
                        <p className="text-right">
                          {airticket_to_supplier?.subTotal?.adt1 || 0}
                        </p>
                        <p className="text-right">
                          {airticket_to_supplier?.subTotal?.chd1 || 0}
                        </p>
                        <p className="text-right">
                          {airticket_to_supplier?.subTotal?.inf1 || 0}
                        </p>
                      </div>
                      {/* Additional Details */}
                      <div className="mt-2 flex justify-between border-t pt-2">
                        <span className="font-bold">Total Cost:</span>
                        <span className="font-bold">
                          ${airticket_to_supplier?.total}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Payment Method</span>
                        <p>
                          {airticket_to_supplier?.transaction_type_name ||
                            "N/A"}
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Payment Made to Supplier</span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>
                            $
                            {airticket_to_supplier?.paymentMade
                              ? airticket_to_supplier?.paymentMade
                              : 0}
                          </p>
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Commission from Supplier</span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>
                            $
                            {airticket_to_supplier?.payment_received_from_supplier
                              ? airticket_to_supplier?.payment_received_from_supplier
                              : 0}
                          </p>
                        </div>
                      </div>
                      {/* {airticket_to_supplier?.recall_commission_to_supplier ||
                        (airticket_to_supplier?.refund && ( */}
                      <div className="flex justify-between">
                        <span className="">Recall commission to supplier</span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>
                            $
                            {isNaN(
                              parseFloat(
                                airticket_to_supplier?.recall_commission_to_supplier
                              )
                            )
                              ? 0
                              : parseFloat(
                                  airticket_to_supplier?.recall_commission_to_supplier
                                )}
                          </p>
                        </div>
                      </div>

                      {/* ))} */}
                      <div className="flex justify-between py-0">
                        <span className="">Refund from supplier</span>
                        <span className="text-right">
                          <span>
                            $
                            {isNaN(airticket_to_supplier?.refund)
                              ? 0
                              : airticket_to_supplier?.refund}
                          </span>
                        </span>
                      </div>
                      <div className="flex justify-between py-0">
                        <span className="">Cash in hand</span>
                        <span className="text-right">
                          <span>
                            $
                            {isNaN(airticket_to_supplier?.cash_in_hand)
                              ? 0
                              : airticket_to_supplier?.cash_in_hand}
                          </span>
                        </span>
                      </div>
                      {/* {airticket_to_supplier?.refund && ( */}
                      <div className="flex justify-between">
                        <span className="">
                          Commission Received from Supplier
                        </span>
                        <div className="flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                          {airticket_to_supplier?.commission_from_supplier ===
                          "true" ? (
                            <span className="text-sm text-green-500">
                              &#10003;
                            </span>
                          ) : (
                            <span className="text-sm text-red-500">
                              &#10007;
                            </span>
                          )}
                        </div>
                      </div>
                      {/* )} */}
                      <div className="flex justify-between">
                        <span className="">Refund Received from Supplier</span>
                        <div className="flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                          {airticket_to_supplier?.refund_received_from_supplier ===
                          "true" ? (
                            <span className="text-sm text-green-500">
                              &#10003;
                            </span>
                          ) : (
                            <span className="text-sm text-red-500">
                              &#10007;
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <span className="">
                          Supplier balance due (Comm. + Refund)
                        </span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>${supplierBalance}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Profit Calculation */}
                  <div className="col-span-2 rounded-lg bg-gray-100 px-2 py-2">
                    <div className="flex items-center justify-between">
                      <div>
                        <h4 className="text-lg font-bold">Agency Profit</h4>
                      </div>
                      <div className="text-2xl font-bold text-green-700">
                        ${profit.toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="">
                <h2 className={`mb-2 ${headingSize} font-semibold`}>
                  Travel Documents Required:
                </h2>
                <div className="grid grid-cols-5 justify-evenly">
                  {documents?.map((doc, index) => {
                    const isTrue = doc.value === true || doc.value === "true";
                    return (
                      <div
                        key={index}
                        className={`${
                          index === 1 ? "col-span-2 justify-center" : ""
                        } mb-2 flex items-center`}
                      >
                        {/* Fake checkbox */}
                        <div className="mr-2 flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                          {isTrue ? (
                            <span className="text-lg text-green-500">
                              &#10003;
                            </span>
                          ) : (
                            <span className="text-lg text-red-500">
                              &#10005;
                            </span>
                          )}
                        </div>
                        <span className="text-lg">{doc.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Remarks Section */}
              <div className="border-t pt-2">
                <h3 className={`mb-2 ${headingSize} font-bold`}>
                  Special Remarks:
                </h3>
                <div className={`${paragraphSize}`}>
                  {special_remarks && <p className="">{special_remarks}</p>}
                  {other_remarks && (
                    <p className="">
                      <strong>Other Notes:</strong> {other_remarks}
                    </p>
                  )}
                </div>
              </div>

              {/* Print Button */}
              <div className="no-print flex justify-center gap-2 p-6">
                <button
                  className="btn btn-primary"
                  onClick={() => window.print()}
                >
                  Print Invoice
                </button>
                {!history && !showSupplier && (
                  <button
                    className={`btn btn-secondary flex items-center gap-2 `}
                    onClick={() => !disable && mailSender(invoice_main_id)} // Prevent click manually
                  >
                    {disable && (
                      <span className="loading loading-spinner loading-sm"></span>
                    )}
                    {disable ? "Sending..." : "Send Mail"}
                  </button>
                )}
              </div>
            </div>

            {/* Footer */}
            <div id="invoice-footer" className="text-center text-sm">
              <Logo
                logo3={logo3}
                width={{
                  logo3: "w-60 mb-2 mt-1",
                }}
              />
              <div className="bg-gray-100 p-4">
                <p className="text-black">
                  2883 Derry Rd E, Mississauga, ON L4T 1A6, Canada
                </p>
                <p className="text-black">
                  Contact: support@katariatravel.ca | Tel: 905 678 1200 | Fax:
                  905 678 1201
                </p>
              </div>
            </div>

            {/* Close Button */}
            <button
              className="no-print hover-text-white btn btn-circle btn-sm absolute left-6 top-6 border border-red-500 bg-white text-sm text-red-500 hover:bg-red-500 hover:text-white"
              onClick={close}
            >
              {"<"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
